//NOTE: it is was stupid desision to keep all filters in one folder. in the future, store them in the corresponding feature folder.
export * from "./general-filter";
export * from "./options";
